<template>
  <!-- 分配用户的对话框 -->
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
       <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色设置</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图区域 -->
    <el-card>
      <el-page-header @back="goBack" :content="roleName"></el-page-header>
      <el-divider></el-divider>
      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button
              plain
              size="small"
              icon="el-icon-plus"
              v-if="roleType !='AGENT' && roleType !='PIPEE' && roleType !='ENGINNER' "
              @click="showAddDialog"
            >新增</el-button>
            <el-button
              plain
              size="small"
              icon="el-icon-delete"
              v-if="roleType !='AGENT' && roleType !='PIPEE' && roleType !='ENGINNER' "
              @click="deletes"
            >删除</el-button>
          </el-button-group>
        </el-col>
      </el-row>

      <!-- 列表区域 -->
      <el-table
        :data="dataList"
        border
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="名称" sortable="custom" prop="userName"></el-table-column>
        <el-table-column label="账号" sortable="custom" prop="loginAccount"></el-table-column>
        <el-table-column label="类型" prop="userType">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.userType==='1'" type="success">总部用户</el-tag>
            <el-tag v-else-if="scope.row.userType==='2'" type="info">代理商</el-tag>
            <el-tag v-else-if="scope.row.userType==='3'" type="info">水工公司</el-tag>
            <el-tag v-else type="warning">水工</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='Y'" type="success">生效</el-tag>
            <el-tag v-else-if="scope.row.status==='N'" type="info">失效</el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加角色的对话框 -->
    <el-dialog :visible="addDialogVisible" width="50%" @close="closeDialog" slot="title">
      <template slot="title">
        <div>
          <h3>添加员工</h3>
          <el-divider style="font-weight:bold;"></el-divider>
        </div>
      </template>
      <el-row>
        <el-col :span="12"></el-col>
        <el-col class="rightContent" :span="12">
          <el-input placeholder="搜索查询" v-model="searchContent" clearable></el-input>
          <el-button type="primary" @click="getSearchDataList">查询</el-button>
        </el-col>
      </el-row>
      <!-- 列表区域 -->
      <el-table
        :data="searchDataList"
        border
        stripe
        @selection-change="handleSelectionChangeSearch"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="名称" sortable="custom" prop="userName"></el-table-column>
        <el-table-column label="账号" sortable="custom" prop="loginAccount"></el-table-column>
        <el-table-column label="类型" prop="userType">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.userType==='1'" type="success">总部用户</el-tag>
            <el-tag v-else-if="scope.row.userType==='2'" type="info">代理商</el-tag>
            <el-tag v-else-if="scope.row.userType==='3'" type="info">水工公司</el-tag>
            <el-tag v-else type="warning">水工</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='Y'" type="success">生效</el-tag>
            <el-tag v-else-if="scope.row.status==='N'" type="info">失效</el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchQueryInfoparams.current"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="searchQueryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      default: false,
    },
  },
  data() {
    return {
      // 获取用户列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,
      //列表
      dataList: [],
      total: 0,
      //角色用户列表的checkbox值
      multipleSelection: [],
      //搜索列表的checkbox值
      multipleSelectionSearch: [],
      //搜索用户列表
      searchDataList: [],
      // 获取用户列表的参数对象
      searchQueryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      searchTotal: 0,
      roleName: this.$route.query.roleName + ' 用户列表',
      roleId: this.$route.query.roleId,
      roleType: this.$route.query.roleType,
      //搜索内容
      searchContent: null,
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.getDataList()
    },
    // 获取 查询用户数据列表
    async getDataList(data) {
      data
        ? (this.queryInfoparams.params = data.params)
        : (this.queryInfoparams.params = {})
      // 分页查询用户
      this.queryInfoparams.params.roleId = this.roleId
      this.$post('role/pageQueryUsers', this.queryInfoparams).then(
        ({ data: res }) => {
          this.dataList = res.records
          this.total = res.total
        }
      )
    },
    showAddDialog() {
      this.addDialogVisible = true
      this.getSearchDataList()
    },
    closeDialog() {
      this.addDialogVisible = false
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听对话框的关闭事件
    goBack() {
      this.$router.back()
    },
    // 获取 查询用户数据列表
    async getSearchDataList() {
      if (this.searchContent != null && this.searchContent != '') {
        this.searchQueryInfoparams.params = {
          roleId: this.roleId,
          keyword: this.searchContent,
        }
      } else {
        this.searchQueryInfoparams.params = { roleId: this.roleId }
      }

      this.$post('user/pageQuery', this.searchQueryInfoparams).then(
        ({ data: res }) => {
          this.searchDataList = res.records
          this.searchTotal = res.total
        }
      )
    },
    // 点击按钮 新增保存
    async saveAdd() {
      if (
        this.multipleSelectionSearch == null ||
        this.multipleSelectionSearch.size <= 0
      ) {
        return this.$message.error('请先勾选数据')
      }
      var ids = []
      this.multipleSelectionSearch.forEach((row) => {
        ids.push(row.id)
      })

      this.$getParams('role/setRoleUsers/' + this.roleId, { idList: ids }).then(
        ({ data: res }) => {
          if (res.ok) {
            // 隐藏添加的对话框
            this.addDialogVisible = false
            // 刷新列表数据
            this.getDataList()
            this.closeDialog()

            return this.$message.success('添加成功')
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },

    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },

    //监控搜索页面 checkbox的选择,为entity的所有值
    handleSelectionChangeSearch(val) {
      this.multipleSelectionSearch = val
      console.log(this.multipleSelectionSearch)
    },
    // 批量删除
    async deletes() {
      if (this.multipleSelection == null || this.multipleSelection.size <= 0) {
        return this.$message.error('请先勾选要删除的数据')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)

      // 弹框询问用户是否删除
      const confirmResult = await this.$confirm(
        '此操作将永久删除, 是否继续?',
        '删除用户',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      // 如果用户确认删除 则 返回值为字符串 confirm
      // 如果用户取消删除 则 返回值为字符串 cancel

      if (confirmResult !== 'confirm') {
        return this.$message.error('取消删除')
      }
      this.$delete(`role/deleteUsers`, { idList: ids }).then(
        ({ data: res }) => {
          if (res.msg === '删除失败') {
            return this.$message.error('删除失败')
          }
          this.$message.success('删除成功')

          this.getDataList()
        }
      )
    },
  },
}
</script>

<style lang="less" scoped>
.rightContent {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}
</style>